import { MemoizedSelector, createSelector } from '@ngrx/store';
import { AppState } from '../../../core/models/appState.model';
import { FlowmeterCalculationState } from './flowmeter-calculation.reducer';

const getFlowmeterCalculationState = (state: AppState) => state.flowmeterCalc;

export const FlowmeterCalculationSelector: MemoizedSelector<AppState, FlowmeterCalculationState> = createSelector(
  getFlowmeterCalculationState,
  (state: FlowmeterCalculationState) => state
);